import React, { Component } from 'react';
import { withRouter } from 'react-router';

import {
  startFacebookSdk,
  getFacebookResponse,
  loginWithFacebook
} from '../plugins/facebook/login';

import { pushOrRedirect, isEmbedded } from '../commons/query';
import { getStepAfterLogin } from './entrar-action';
import { sendSuccessfulyMessage, sendFailMessage } from '../commons/utils/post-message';

class FacebookButton extends Component {
  state = {
    error: '',
    loading: false
  };

  componentDidMount() {
    startFacebookSdk();
  }

  render() {
    return (
      <div className="facebookLogin">
        <div id="fb-root" />
        <button className="facebookLogin-btnHover" onClick={this.openFacebookAuthPopup} />
        <div
          className="fb-login-button"
          data-max-rows="1"
          data-size="large"
          data-width="100%"
          data-button-type="continue_with"
          data-show-faces="false"
          data-auto-logout-link="false"
          data-use-continue-as="true"
        />
        {this.state.loading && <div className="loading" />}
        {this.state.error && (
          <p onAnimationEnd={this.cleanErrors} className="facebookLogin-error">
            {this.state.error}
          </p>
        )}
      </div>
    );
  }

  cleanErrors = () => this.setState({ error: '' });

  displayErrorMessage = error => this.setState({ error });

  setLoading = status => this.setState({ loading: status });

  openFacebookAuthPopup = () => {
    this.cleanErrors();
    this.setLoading(true);
    getFacebookResponse()
      .then(response => {
        loginWithFacebook(response)
          .then(getStepAfterLogin)
          .then(url => {
            if (isEmbedded()) {
              sendSuccessfulyMessage();
            } else {
              pushOrRedirect(this.props.history.push, url);
            }
          })
          .catch(error => {
            this.setLoading(false);
            this.displayErrorMessage('Não foi possível completar seu cadastro');
            sendFailMessage(error);
          });
      })
      .catch(() => {
        this.setLoading(false);
        this.displayErrorMessage('Ocorreu um erro na sua autenticação');
      });
  };
}

export default withRouter(FacebookButton);
